module.exports = __webpack_public_path__ + "media/images/shapes/blurs/blur-4-ca369f66995cf8e4d2fadd5bc0b028ee.svg";